import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AuthGuard } from '../app/guards/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { YearfourComponent } from './calender/yearfour/yearfour.component';
import { OnlineTestsComponent } from './calender/Online/online-tests/online-tests.component';
import { ElevPlusOnlineComponent } from './calender/Online/elev-plus-online/elev-plus-online.component';
import { YearFourOnlineComponent } from './calender/Online/year-four-online/year-four-online.component';
import { LlpPageComponent } from './llp-page/llp-page.component';


const routes: Routes = [
  { path: '', loadChildren: () => import('../app/front-layout/front-layout.module').then(m => m.FrontLayoutModule) },
  { path: 'signin', loadChildren: () => import('../app/signin/signin.module').then(m => m.SigninModule) },
  { path: 'forgot-password', loadChildren: () => import('../app/forget-password/forget-password.module').then(m => m.ForgetPasswordModule) },
  { path: 'signup', loadChildren: () => import('../app/signup/signup.module').then(m => m.SignupModule) },
  { path: 'dashboard', loadChildren: () => import('../app/my-account/my-account.module').then(m => m.MyAccountModule), canActivate: [AuthGuard] },
  { path: 'vendor-dashboard', loadChildren: () => import('../app/vendor-dashboard/vendor-dashboard.module').then(m => m.VendorDashboardModule), canActivate: [AuthGuard] },
  { path: 'email-verify/:id', loadChildren: () => import('../app/verify-email/verify-email.module').then(m => m.VerifyEmailModule) },
  { path: 'yearfour-topictest', component: YearfourComponent },
  { path: 'online-tests', component: OnlineTestsComponent },
  { path: 'elev-plus-online', component: ElevPlusOnlineComponent },
  { path: 'year-four-online', component: YearFourOnlineComponent },
  { path: 'india', component: LlpPageComponent },

  { path: '**', redirectTo: '/page-not-found'},
  { path: 'page-not-found', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
